<app-header></app-header>
<div class="container mt10">
    <div class="row">
        <div class="col-xs-12 ">
            <div class="cat-name"><a (click)="back()"><i class="fa fa-long-arrow-left" aria-hidden="true"></i></a>
                {{categoryName}}</div>
        </div>
        <div class="container">
            <div class="row" *ngFor="let g of viewGamesData; let i= index">
                <div class="col-xs-4 mt20">
                    <a [routerLink]="['/game-play/', g.gameid, 'home']" (click)="downloadLog(g.displayname);">
                        <img src="{{g.previewurl}}" alt="" class="round-corner" width="100%">
                    </a>

                </div>
                <div class="col-xs-8 mt20">
                    <div class="game-title">{{g.displayname}}</div>
                    <div class="desc" (click)="discribModal(i, g.description)">{{g.description}}</div>
                    <div class="rating">★★★</div>
                </div>
            </div>
            <div class="popup-dis" *ngIf="discrib">
                <div class="modal-dialog modal-width">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title modal-title-color">{{discrb}}</h3>
                            <a type="button" class="btn btn-primary" (click)="closedis()">close</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>

<!-- Modal -->
<div class="popup" *ngIf="showModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true" data-dismiss="modal">×</span>
                </button> -->
                <!-- <h3 class="modal-title modal-title-color">Please Subscribe first</h3> -->
                <h3 class="modal-title modal-title-color">Please use your Safaricom Internet to access this service.
                </h3>
                <a type="button" class="btn btn-primary" (click)="closeModal()">OK</a>
            </div>

        </div>
    </div>
</div>